'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$() {
  this.aCu = null;
  this.aCv = false;
}
export { $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$ as $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$ };
$p = $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$;
/** @constructor */
function $h_Lapp_data_OrganizationAddress$package$OrganizationAddress$() {
}
export { $h_Lapp_data_OrganizationAddress$package$OrganizationAddress$ as $h_Lapp_data_OrganizationAddress$package$OrganizationAddress$ };
$h_Lapp_data_OrganizationAddress$package$OrganizationAddress$.prototype = $p;
$p.aA = (function() {
  if ((!this.aCv)) {
    this.aCu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aCv = true;
  }
  return this.aCu;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_OrganizationAddress$package$OrganizationAddress$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationAddress$package$OrganizationAddress$, "app.data.OrganizationAddress$package$OrganizationAddress$", ({
  Ee: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_OrganizationAddress$package$OrganizationAddress$ as $d_Lapp_data_OrganizationAddress$package$OrganizationAddress$ };
var $n_Lapp_data_OrganizationAddress$package$OrganizationAddress$;
function $m_Lapp_data_OrganizationAddress$package$OrganizationAddress$() {
  if ((!$n_Lapp_data_OrganizationAddress$package$OrganizationAddress$)) {
    $n_Lapp_data_OrganizationAddress$package$OrganizationAddress$ = new $c_Lapp_data_OrganizationAddress$package$OrganizationAddress$();
  }
  return $n_Lapp_data_OrganizationAddress$package$OrganizationAddress$;
}
export { $m_Lapp_data_OrganizationAddress$package$OrganizationAddress$ as $m_Lapp_data_OrganizationAddress$package$OrganizationAddress$ };
//# sourceMappingURL=app.data.-Organization-Address$package$-Organization-Address$.js.map
